<router-outlet></router-outlet>
<ideapa-loader [show]="isLoaderVisible$ | ngrxPush"></ideapa-loader>
@if (activeTab$ | ngrxPush; as activeTab) {
  <ideapa-keyboard-shortcuts-listener
    [activeTab]="activeTab"
    [showHelp]="(showHelp$ | ngrxPush) || false"
  ></ideapa-keyboard-shortcuts-listener>
}
